import { modifier } from 'ember-modifier';

export default modifier((element, [observer, destructor]) => {
  if (!observer) {
    return undefined;
  }

  observer.observe(element);

  return () => {
    observer.unobserve(element);
    destructor?.(element);
  }
}, { eager: false });
